import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import {
	API_RESOURCES,
	createApiUpdateAction,
	HTTP_REQUEST_METHODS,
	createApiReadAction,
	createApiCreateAction,
	createApiDeleteAction
} from '../../util/api';

export const getAccounts = (engagementId, queryString) =>
	createApiReadAction(
		types.GET_ACCOUNTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ACCOUNTS]: null
		},
		queryString,
		{resolve: true}
	);

/*export const getConclusionAccounts = (url) => {
	return {
		type: types.GET_ACCOUNTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getAssertionsForAccountId = (url) => {
	return {
		type: types.GET_ASSERTIONS_FOR_ACCOUNTID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getAssertionsForAccountIdSEM = (url) => {
	return {
		type: types.GET_ASSERTIONS_FOR_ACCOUNTID_SEM,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getScotsForAssertionIds = (url) => {
	return {
		type: types.GET_SCOTS_FOR_ASSERTIONIDS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const removeAccountReview = (url) => {
	return {
		type: types.DELETE_REVIEWS_FOR_ACCOUNTID,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
};

export const getAccountsForEdit = (url) => {
	return {
		type: types.GET_ACCOUNTS_EDIT,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export function addAccountReview(url, resource) {
	return {
		type: types.ADD_REVIEWS_FOR_ACCOUNTID,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: resource
			}
		}
	};
}

export function updateStoreForScots(wcgwId, relatedTasksCounter, scots) {
	let scotsContainingWcgwToUpdate = scots.filter((scot) => scot.wcgws.some((wcgw) => wcgw.wcgwId === wcgwId));

	scotsContainingWcgwToUpdate.map((mappedScot) => {
		let found = scots.find((scot) => scot.id === mappedScot.id).wcgws.find((wcgw) => wcgw.wcgwId === wcgwId);
		if (found) {
			found.relatedTasksCounter = relatedTasksCounter;
		}
	});

	return {
		type: types.GET_SCOTS_FOR_ASSERTIONIDS,
		response: scots
	};
}

export function updateStoreForAccountAssertions(taskId, sourceNatureId, sourceNatureType, accountAssertions) {
	accountAssertions.accountTasks.map((acctask) => {
		if (acctask.taskId === taskId) {
			if (sourceNatureType === 'Source') {
				acctask.taskSourceTypeId = sourceNatureId;
			} else {
				acctask.taskNatureTypeId = sourceNatureId;
			}
		}
	});

	return {
		type: types.GET_ASSERTIONS_FOR_ACCOUNTID_SEM,
		response: accountAssertions
	};
}*/

export const getAccountById = (engagementId, accountId, queryParameters, actionProps) => {
	const defaultQueryParams = {
		includeAssertions: true,
		includePspIndexes: true,
		includeRelatedRisks: true,
		includeHelix: true,
		includeEntities: true,
		includeRelatedDocuments: true
	};

	const url =
		env.getBaseURL(serviceURL, engagementId) +
		`Accounts/${accountId}?` +
		Utility.getAccountParams(queryParameters || defaultQueryParams);

	return {
		type: types.GET_ACCOUNT_BY_ID,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		resolve: true
	};
};

export const updateAccount = (engagementId, accountId, data, actionProps) => {
	const action = createApiUpdateAction(
		types.UPDATE_ACCOUNT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ACCOUNTS]: accountId
		},
		data,
		HTTP_REQUEST_METHODS.PUT,
		actionProps
	);
	action.resolve = true;
	return action;
};

export const createAccount = (engagementId, data, actionProps) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Accounts`;
	return {
		type: types.CREATE_ACCOUNT,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		}
	};
};

export function cleanAccount() {
	return {
		type: types.CLEAN_ACCOUNT
	};
}

export function deleteAccount(engagementId, accountId) {
	let url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Accounts' + '/' + accountId;

	return {
		type: types.DELETE_ACCOUNT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		accountId
	};
}

export function putAssociatedHelixAccounts(engagementId, accountList) {
	const url = `${env.getBaseURL(serviceURL, engagementId)}HelixAccountMappings`;

	return {
		type: types.SAVE_BATCH_HELIX_CANVAS_ACCOUNT_RELATIONS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: accountList
			}
		}
	};
}

export function getAllEngagementAccounts(engagementId, actionProps, queryParameters) {
	const defaultQueryString = {
		orderBy: 'AccountName',
		IncludeAssertions: true,
		IncludePspIndexes: true,
		IncludeRelatedRisks: true,
		IncludeHelix: true,
		IncludeEntities: true,
		IncludeRelatedDocuments: true
	};

	return createApiReadAction(
		types.GET_ACCOUNTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ACCOUNTS]: null
		},
		queryParameters || defaultQueryString,
		{...actionProps, resolve: true}
	);
}

export function areAllCanvasAccountsMappedToHelixAccounts(engagementId) {
	const url = `${env.getBaseURL(serviceURL, engagementId)}HelixAccountMappings`;

	return {
		type: types.GET_IS_HELIX_CANVAS_ACCOUNT_MAPPINGS_SUCCESSFULL,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function saveSentAssociatedHelixAccounts(accountList) {
	return {
		type: types.SAVE_SENT_ASSOCIATED_HELIX_ACCOUNTS,
		accountList
	};
}

export function relateEntityAccount(engagementId, accountId, stEntityId) {
	return createApiCreateAction(
		types.RELATE_ENTITY_ACCOUNT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: stEntityId,
			[API_RESOURCES.ACCOUNT]: undefined
		},
		{accountId},
		{accountId, stEntityId}
	);
}

export function unrelateEntityAccount(engagementId, accountId, stEntityId) {
	return createApiDeleteAction(
		types.UNRELATE_ENTITY_ACCOUNT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.MULTIENTITY]: stEntityId,
			[API_RESOURCES.ACCOUNT]: accountId
		},
		{accountId, stEntityId}
	);
}

export function updateStoreAccountRelation(data) {
	return {
		type: types.UPDATE_STORE_ACCOUNT_ASSERTION,
		payload: data
	};
}